import { usePsfSharePageData } from '#src/app/pages/psf/share/pageContext';
import { shouldShowSharingGoalFlow } from '#src/app/pages/psf/share/shared/utils';
import { useIsMobile } from '#src/app/shared/hooks/userAgent';

/**
 * Whether SharingGoalFlow is actually rendering right now -- the single source of truth every
 * consumer (PageBody's render branch, its share_feed_view tracking effect, useRedirect's post-share
 * destination) must read, rather than re-deriving locally. Every real psf_share_goal_ux_experiment
 * variation (including variant_2, which renders SharingGoalFlow with inputVariant="none" -- the same
 * screen, minus the goal slider/chips) reaches this same flow, so the experiment plays no part here.
 */
export function useShouldShowSharingGoalFlow(): boolean {
	const {
		data: {
			skip,
			featureConfigs: { isSuperRecruiterFlowEnabled, isShareSlideUpEnabled },
		},
	} = usePsfSharePageData();
	const isMobile = useIsMobile();

	return shouldShowSharingGoalFlow({
		skip,
		isSuperRecruiterFlowEnabled,
		isShareSlideUpEnabled,
		isMobile,
	});
}
